import { createContext, useContext } from 'react';

const UIContext = createContext(null);

export const useUI = () => {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error('useUI must be used inside AppProvider');
  return ctx;
};

export default UIContext;
